<template lang="pug">
    div(@change="Reset")
      v-dialog(v-model="showDialog" persistent max-width="930px")
        v-layout(row, justify-center)
          v-flex(text-xs-center)
            v-card
              div(v-if="showDialog")
                v-layout
                  v-flex(text-xs-center)
                    img.dialog_img(:src="getImage")
                v-spacer.my-1.py-4
                v-card-text.feedtitle
                  | {{ getFeedback.title }} 
                v-card.questionCard(flat)
                  v-card-text.dialog_text.textos
                    p.text-sm-left.px-4.px-sm-5(v-for="label in getFeedback.labels" v-show="match(answers,label.id)" v-html="getText(label.text)")
                      | {{label.text}}
              ButtonNext.buttones1
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonNext from "@/components/button-next/button-next";
import { debug } from 'util';
export default {
  name: 'OptionalFeedback',
  components: {
    ButtonNext
  },
  props:{
    answers:{
      type: Array,
      default: []
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['currentStep']),
    getFeedback() {
      return this.currentStep.feedbacksModal.find(f => f.type === 'positive');
    },
    getImage() {
        return require(this.getFeedback.type === 'positive' ? '@/assets/ManoArriba.png' : '@/assets/ManoStop.png');
    }
  },
	data(){
    return {
      show: false
		}
	},
  mounted:function(){
    this.show = false;
    //this.showDialog = false;
  },
	methods:{
		change(){
			this.state = true;
		},
    Reset(){
      this.currentStep.state = false;
    },
    match(a, id){
      return a.find(f => f.id === id);
    },
    getText(text) {
      if(text) {
        let replaceData = text.split('|');
        if (replaceData.length > 1) {
          text = text.replace(`|${replaceData[1]}|`, this.currentStep.data[replaceData[1]]);
        }      
      }
      return text;
    }
  }
}
</script>

<style scoped>
@import 'feedback-modal.scss';
</style>
